<template>
<TheStdLayout :title="$t('Goals & evaluations')">

	<GoalEvaluation :withSchedulingSegmentsOptions="true"></GoalEvaluation>

</TheStdLayout>
</template>


<script lang="ts">

import GoalEvaluation from "@/components/GoalEvaluation.vue";

export default {

	mounted() {},

	async created() {
	},

	props: {

	},

	components: {
		GoalEvaluation,
	},

	data() {
		return {

		}
	},

	methods: {}

}
</script>
